/**
 * donation-form — chrome-string entry point. SYNC: see ../_SYNC.md.
 *
 * Wraps the host's vue-i18n so step views never hardcode the `donationForm.`
 * namespace prefix: `tf(key)` resolves `t('donationForm.' + key)`. It forces the
 * ENGINE's ACTIVE locale (`ctx.lang`) via vue-i18n's per-call `{ locale }`
 * override, so chrome follows the form's chosen language — NOT the host global
 * locale (the oportal back-office UI language). useChrome and
 * components/layout/StepProgress.vue are the only modules that import vue-i18n
 * (host-allowed); the engine (context/donationContext.ts) never does — the
 * dependency runs one way (useChrome → donationContext), so there is no import
 * cycle and the engine stays pure.
 */
import { useI18n } from "vue-i18n";
import { useDonation } from "../context/donationContext";
export function useChrome() {
    const { t } = useI18n();
    const { lang } = useDonation(); // every useChrome caller renders inside <DonationForm> → ctx always provided
    return {
        // Resolve in the ENGINE's active locale (ctx.lang == state.lang), NOT the host global locale.
        tf: (key, params) => t(`donationForm.${key}`, params ?? {}, { locale: lang.value }),
    };
}
